import React, { useEffect } from "react";
import { Modal, Input, Form, Button, Switch } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Locale } from "../../utils";
import TranslateBtn from "../../components/product/TranslateBtn";

const i18n = Locale.getInstance();

const EditBuildingForm = ({ buildingData, onCancel, onFinish, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!buildingData) {
      return undefined;
    }

    if (buildingData.id) {
      const { zh_name, ug_name, order, enabled } = buildingData;
      form.setFieldsValue({
        zh_name,
        ug_name,
        order,
        enabled: enabled !== false,
      });
    } else {
      form.setFieldsValue({
        enabled: true,
        order: 0,
      });
    }

    return () => {
      form.resetFields();
    };
  }, [buildingData, form]);

  return (
    <Modal
      title={
        buildingData && buildingData.id
          ? i18n.t("communityBuilding.edit")
          : i18n.t("communityBuilding.add")
      }
      open={!!buildingData}
      onCancel={onCancel}
      footer={null}
      forceRender
      destroyOnClose
      getContainer={() => document.body}
      zIndex={1100}
    >
      <Form labelCol={{ span: 6 }} form={form} onFinish={onFinish}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue, setFieldsValue }) => (
            <Form.Item
              rules={[
                { required: true, message: i18n.t("communityBuilding.zhNameHint") },
              ]}
              label={i18n.t("communityBuilding.zhName")}
              name="zh_name"
            >
              <Input
                placeholder={i18n.t("communityBuilding.zhNameHint")}
                addonAfter={
                  <TranslateBtn
                    context={getFieldValue("zh_name")}
                    onFinish={(value) =>
                      setFieldsValue({
                        ug_name: value,
                      })
                    }
                    from="zh"
                    to="ug"
                  />
                }
              />
            </Form.Item>
          )}
        </Form.Item>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue, setFieldsValue }) => (
            <Form.Item
              rules={[
                { required: true, message: i18n.t("communityBuilding.ugNameHint") },
              ]}
              label={i18n.t("communityBuilding.ugName")}
              name="ug_name"
            >
              <Input
                placeholder={i18n.t("communityBuilding.ugNameHint")}
                addonAfter={
                  <TranslateBtn
                    context={getFieldValue("ug_name")}
                    onFinish={(value) =>
                      setFieldsValue({
                        zh_name: value,
                      })
                    }
                    from="ug"
                    to="zh"
                  />
                }
              />
            </Form.Item>
          )}
        </Form.Item>
        <Form.Item label={i18n.t("community.order")} name="order">
          <Input type="number" />
        </Form.Item>
        <Form.Item
          name="enabled"
          valuePropName="checked"
          label={i18n.t("communityBuilding.enabled")}
        >
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 10 }}>
          <Button
            disabled={loading}
            loading={loading}
            type="primary"
            htmlType="submit"
          >
            {i18n.t("sales.submit")}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditBuildingForm;
